module.exports = __webpack_public_path__ + "media/images/acad_council/laura_esserman-b7f21285469f6d0d522f019b7a6452a6.jpg";